import { ReduxOrganization, ReduxPortalConfig, ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import { constructFormAddressString } from 'app/views/forms/common/Common'
import { checkFormValidity } from 'app/views/forms/FormHelpersValidation'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getFormPage } from '../sfData/sfForms'

export const useOrganizationValidityCheck = (): { orgDetailsInvalid: boolean } => {
  const config = useSelector<ReduxState, ReduxPortalConfig>(state => state.configuration)
  const organization = useSelector<ReduxState, ReduxOrganization>(state => state.organization)
  const user = useSelector<ReduxState, ReduxUser>(state => state.user)

  const [isValid, setIsValid] = useState<boolean>(true)

  useEffect(() => {
    if (organization.id) {
      getFormPage(config.FORM_ORGANIZATION_DETAILS).then(form => {
        checkFormValidity({
          formId: config.FORM_ORGANIZATION_DETAILS,
          id: constructFormAddressString({
            ids: {
              Account: organization.id,
              User: user.userId
            },
            objectsConnected: form.objectsConnected
          })
        }).then(isValid => {
          setIsValid(isValid)
        })
      })
    }
  }, [organization])

  return { orgDetailsInvalid: !isValid && 'id' in organization }
}
